import { useLazyQuery } from "@apollo/client";
import { EXPORT_PAYMENT_CHECK } from "components/gql/gql_queries_export";

import { logGQLError } from "data/functions";

export function ExportPaymentCheckQuery() {
  const queryName = "ExportPaymentCheck";
  const [refetch, variables] = useLazyQuery(EXPORT_PAYMENT_CHECK, {
    fetchPolicy: "no-cache",
    onError: (e) => {
      logGQLError(queryName, e);
      // setLogined(false);
    },
  });
  return [refetch, variables];
}
